import React, { useState } from "react";
import { Link } from "react-router-dom";
import WhatsAppSelector from "../../../components/feature/WhatsAppSelector";

export default function HeroSection() {
  const [whatsappOpen, setWhatsappOpen] = useState<boolean>(false);

  return (
    <section
      className="relative min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/cd1996cd6a3d75bf49526a2845eb25df.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center min-h-screen">
          {/* Text Content */}
          <div className="text-center lg:text-left">
            {/* Logo */}
            <div className="flex justify-center lg:justify-start mb-8">
              <img
                src="https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/787d717316e026e399e40d0c21419a41.png"
                alt="LION URBAN Logo"
                className="w-80 md:w-96 lg:w-[420px] h-auto object-contain"
              />
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Publicidad e Impresión
              <span className="block text-green-400">de Alto Impacto</span>
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-gray-200 mb-8 max-w-xl lg:max-w-2xl mx-auto lg:mx-0 leading-relaxed">
              Transformamos tus ideas en realidades visuales
              <span className="block">que captan la atención y generan resultados</span>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <button
                onClick={() => setWhatsappOpen(true)}
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Solicitar Cotización
              </button>
              <Link
                to="/products"
                onClick={() => window.scrollTo(0, 0)}
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Ver Productos
              </Link>
            </div>
          </div>

          {/* Mascot */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/7d31b8045d80057b2b2209dba23a3f63/82ef2885dcd02fc0b637bded3a94495b.png"
                alt="León Mascota LION URBAN"
                className="w-80 h-auto lg:w-96 xl:w-[450px] object-contain"
              />
              {/* Glow effect */}
              <div className="absolute inset-0 bg-green-400/20 rounded-full blur-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator - Hidden on mobile */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden lg:block">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>

      <WhatsAppSelector
        isOpen={whatsappOpen}
        onClose={() => setWhatsappOpen(false)}
        productName="Cotización General"
      />
    </section>
  );
}